import { type StoreGroupsFormProps } from '../../form/StoreGroupsForm'
import { useUpdateStoreGroup } from '../../../graphql/update.hooks'

export const useUpdateStoreGroupOnSubmit = () => {
  const { updateStoreGroup, updatedStoreGroup, loading, error } = useUpdateStoreGroup()

  const handleSubmit: StoreGroupsFormProps['handleSubmit'] = ({
    existingStoreGroupId: id,
    name,
    selectedLocationIds: retailerLocationIds,
  }) => {
    if (!id) {
      throw new Error('Attempted to update store group, but no existingStoreGroupId was provided')
    }

    updateStoreGroup({
      id,
      name,
      retailerLocationIds,
    })
  }

  return {
    handleSubmit,
    updatedStoreGroup,
    loading,
    error,
  }
}
